import React, { useState } from "react";
import { Tooltip, Fab, Typography, Grid } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import GetAppIcon from '@material-ui/icons/GetApp';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ReactImageMagnify from 'react-image-magnify';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import { useDispatch } from "react-redux";
import { deleteFileCertificado, deleteFileCertificadoStage } from "../../actions/certificados";

const styles = {
  root: {
    height: '100%'
  },
  rootGiro: {
    marginTop: -5
  },
  rootMobileLandscape: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },
  media: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& > *": {
      maxHeight: "100%",
    },
    paddingTop: "1rem",
  },
  mediaMobile: {
    position: "relative",
    top: "50%",
  },
  mediaMobileLandscape: {},
  text: {
    textAlign: "center",
    maxWidth: "80%",
    margin: "0 auto"
    // paddingTop: 32,
  },
  textMobile: {
    // paddingTop: 30,
    "& $title": {
      marginBottom: 8,
    },
  },
  textMobileLandscape: {
    minWidth: 300,
    maxWidth: "calc(50% - 48px)",
    padding: "24px 24px 128px",
    flex: "0 1",
    alignSelf: "center",
    textAlign: "left",
    margin: 0,
  },
  title: {
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "32px",
    marginBottom: 12,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textShadow: 'black 0em 0.1em 0.3em'
    //color: "#fff",
  },
  subtitle: {
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "18px",
    margin: 0,
    textShadow: 'black 0.1em 0.1em 0.3em'
    //color: "#fff",
  },
};

function Slide(props) {
  const {
    classes,
    media,
    mediaBackgroundStyle,
    subtitle,
    titulo,
    mobile,
    landscape,
    url,
    idFileCertificado,
    esPreAfiliacion,
    idPreAfiliado,
    ...other
  } = props;
  const dispatch=useDispatch()
  const [rotation, setRotation] = useState(0)
  const mobileLandscape = mobile && landscape;

  const handleDescargaClick = (e) => {
    e.stopPropagation() || e.preventDefault();
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.download = "archivo"
    link.click();
  };

  const handleDeleteFile = (e) => {
    esPreAfiliacion ? dispatch(deleteFileCertificadoStage(idFileCertificado, idPreAfiliado)) : dispatch(deleteFileCertificado(idFileCertificado))
  };

  const esImagen = (url) => {
    let result=false;

    if(url.toLowerCase().search("pdf")===-1 && url.toLowerCase().search("xls")===-1 && url.toLowerCase().search("xlsx")===-1){
      result= true;
    }
    return result
  }

  const rotate = () => {
    let newRotation = rotation + 90;
    if (newRotation >= 360) {
      newRotation = - 360;
    }
    setRotation(newRotation)
  }

  const rotateleft = () => {
    let newRotation = rotation - 90;
    if (newRotation >= 360) {
      newRotation = - 360;
    }
    setRotation(newRotation)
  }

  return (
    <div
      className={classNames(classes.root, {
        [classes.rootMobile]: mobile,
        [classes.rootMobileLandscape]: mobileLandscape,
      })}
      {...other}
    >
      <Grid container style={{ padding: "1rem", paddingBottom: 0 }}>
        <Grid item xs={1}>
          {
            props.delete &&
            <Tooltip title="Eliminar" aria-label="delete">
              <Fab
                size="small"
                color="primary"
                style={{ backgroundColor: "red", zIndex:1 }}
                onClick={handleDeleteFile}
              >
                <DeleteForeverIcon />
              </Fab>
            </Tooltip>
          }

        </Grid>
        <Grid item xs={10}>
          <div
            className={classNames(classes.media, {
              [classes.mediaMobile]: mobile,
              [classes.mediaMobileLandscape]: mobileLandscape,
            })}
            style={{ transform: `rotate(${rotation}deg)` }}
          >

            {
              esImagen(url) 
                ?
                <ReactImageMagnify
                  {...{
                    smallImage: {
                      alt: "Documentacion",
                      isFluidWidth: true,
                      width: 'auto',
                      height: 450,
                      src: url,
                      sizes: { width: '100px', height: '100px' },
                    },
                    enlargedImagePosition: 'over',
                    enlargedImageContainerDimensions: { width: '100%', height: '100%' },
                    largeImage: {
                      src: url,
                      width: 1200,
                      height: 1800,
                    },
                  }}
                />
                :
                media
            }
          </div>
        </Grid>
        <Grid item xs={1}>
          <Tooltip title="Descargar" aria-label="delete">
            <Fab
              size="small"
              color="primary"
              onClick={handleDescargaClick}
              style={{zIndex:1, float:"right" }}
            >
              <GetAppIcon />
            </Fab>
          </Tooltip>
        </Grid>
      </Grid>
      <div
        className={classNames(classes.text, {
          [classes.textMobile]: mobile,
          [classes.textMobileLandscape]: mobileLandscape,
        })}
      >
        <Typography className={classes.title}>{titulo}</Typography>
        <Typography className={classes.subtitle}>{subtitle}</Typography>

      </div>
      {
        esImagen(url) &&
        <Grid container direction="row" justify="center" style={{ padding: "1rem" }}>
          <Grid item xs={2} >
            <Fab
              className={classes.rootGiro}
              color="secondary"
              size="medium"
              onClick={rotate}
              style={{ float: "left" }}
            >
              <RotateRightIcon />
            </Fab>
          </Grid>
          <Grid xs={8} />
          <Grid item xs={2} >
            <Fab
              className={classes.rootGiro}
              color="secondary"
              size="medium"
              onClick={rotateleft}
              style={{ float: "right" }}
            >
              <RotateLeftIcon />
            </Fab>
          </Grid>
        </Grid>
      }

    </div>
  );
}

export default withStyles(styles)(Slide);
